import { useTranslation } from "@refinedev/core";

import { Button, Paper, Stack, Typography } from "@mui/material";

export interface DeactivateConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeactivateConfirmDialog = ({ open, onConfirm, onCancel }: DeactivateConfirmDialogProps) => {
  const { translate } = useTranslation();

  if (!open) {
    return null;
  }

  const prefix = "pages.practitioner.editModal.deactivateConfirm";

  const title = translate(`${prefix}.title`);
  const description = translate(`${prefix}.description`);
  const warning = translate(`${prefix}.warning`);
  const confirmLabel = translate(`${prefix}.confirm`);
  const cancelLabel = translate(`${prefix}.cancel`);

  return (
    <Paper elevation={0} variant="alertError" data-testid="deactivate-confirm-dialog">
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3" textAlign="center" color="text.primary">
          {title}
        </Typography>

        <Typography variant="body2" textAlign="center" color="text.primary">
          {description}
        </Typography>

        <Typography variant="body2" textAlign="center" color="text.primary">
          {warning}
        </Typography>

        <Stack direction="row" spacing={2} pt={1}>
          <Button
            variant="outlined"
            size="large"
            color="primary"
            onClick={onCancel}
            data-testid="deactivate-confirm-dialog-cancel"
          >
            {cancelLabel}
          </Button>
          <Button
            variant="capsule"
            color="error"
            onClick={onConfirm}
            data-testid="deactivate-confirm-dialog-confirm"
            autoFocus
          >
            {confirmLabel}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};
